import { CompanyCurrencyEnumType } from "@oysterhr/schema"

// ACH
import AchLandingPage from "./pages/CompanyPaymentMethodsPage/ach/pages/AchLandingPage/AchLandingPage"
import AchFlowPage from "./pages/CompanyPaymentMethodsPage/ach/pages/AchFlowPage/AchFlowPage"
import NewAchFlowPage from "./pages/CompanyPaymentMethodsPage/ach/pages/AchFlowPage/NewAchFlowPage"
import VerifyStripeAchPaymentMethod from "./pages/CompanyPaymentMethodsPage/ach/pages/VerifyStripeAchPaymentMethodPage/VerifyStripeAchPaymentMethodPage"
import AuthorizePaymentMethod from "./pages/CompanyPaymentMethodsPage/ach/pages/AuthorizePaymentMethodPage/AuthorizePaymentMethodPage"
// BACS
import BacsLandingPage from "./pages/CompanyPaymentMethodsPage/bacs/BacsLandingPage"
// PAD
import PadLandingPage from "./pages/CompanyPaymentMethodsPage/pad/PadLandingPage"
// SEPA
import SepaLandingPage from "./pages/CompanyPaymentMethodsPage/sepa/pages/SepaLandingPage/SepaLandingPage"
import SepaFlowPage from "./pages/CompanyPaymentMethodsPage/sepa/pages/SepaFlowPage/SepaFlowPage"
import NewSepaFlowPage from "./pages/CompanyPaymentMethodsPage/sepa/pages/NewSepaFlow/NewSepaFlowPage"
import SepaMandatePage from "./pages/CompanyPaymentMethodsPage/sepa/pages/SepaMandatePage/SepaMandatePage"
// Dashboard
import { CompanyPaymentMethodsPage } from "./pages/CompanyPaymentMethodsPage/CompanyPaymentMethodsPage"
// Helpers
import { WithCompanyPaymentsSettingsRoute } from "./pages/CompanyPaymentMethodsPage/outlets/WithCompanyPaymentsSettingsRoute"
import { CompanyPaymentsMandateSetupProtectedRoute } from "./pages/CompanyPaymentMethodsPage/outlets/CompanyPaymentsMandateSetupProtectedRoute"
import { PaymentMethodsProtectedRoute } from "~/router/outlets/PaymentMethodsProtectedRoute"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"
import { OysterRouter } from "~/router/type"
import { PaymentEngagementType } from "./pages/CompanyPaymentMethodsPage/enums"

export const companyPaymentRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      element: <WithCompanyPaymentsSettingsRoute />,
      children: [
        {
          element: <PermissionProtectedRoute permissions={["payment_information"]} />,
          children: [
            {
              path: "payment-methods",
              element: <CompanyPaymentMethodsPage />,
            },
            {
              path: "payment-methods/:checkoutState",
              element: <CompanyPaymentMethodsPage />,
            },
          ],
        },
      ],
    },
  ],
  DeprecatedFullScreen: [
    {
      element: <WithCompanyPaymentsSettingsRoute />,
      children: [
        {
          element: <PermissionProtectedRoute permissions={["payment_information"]} />,
          children: [
            {
              element: (
                <PaymentMethodsProtectedRoute
                  rules={{
                    companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Usd],
                  }}
                />
              ),
              children: [
                {
                  path: "payment-methods/verify-stripe-ach-payment-method",
                  element: <VerifyStripeAchPaymentMethod />,
                },
              ],
            },
            {
              element: (
                <PaymentMethodsProtectedRoute
                  rules={{
                    companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Usd],
                  }}
                />
              ),
              children: [
                {
                  path: "payment-methods/:paymentMethodId/authorize",
                  element: <AuthorizePaymentMethod />,
                },
              ],
            },
            //  -------- SEPA --------
            {
              element: (
                <PaymentMethodsProtectedRoute
                  rules={{
                    companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Eur],
                  }}
                />
              ),
              children: [
                // NOTE: This is old SEPA payment flow (fte + contractor)
                {
                  path: "payment-methods/sepa-bank-details",
                  element: <SepaFlowPage />,
                },
              ],
            },
            {
              element: (
                <PaymentMethodsProtectedRoute
                  rules={{
                    companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Eur],
                  }}
                />
              ),
              children: [
                {
                  path: "payment-methods/sepa-landing-page",
                  element: <SepaLandingPage type={PaymentEngagementType.Combined} />,
                },
              ],
            },
            {
              element: (
                <CompanyPaymentsMandateSetupProtectedRoute>
                  <PaymentMethodsProtectedRoute
                    rules={{
                      companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Eur],
                    }}
                  />
                </CompanyPaymentsMandateSetupProtectedRoute>
              ),
              children: [
                {
                  path: "payment-methods/sepa-landing-page/contractor",
                  element: <SepaLandingPage type={PaymentEngagementType.Contractor} />,
                },
                {
                  path: "payment-methods/sepa-landing-page/fte",
                  element: <SepaLandingPage type={PaymentEngagementType.Fte} />,
                },
                {
                  path: "payment-methods/sepa/mandate",
                  element: <SepaMandatePage />,
                },
                // NOTE: This is new SEPA payment flow
                {
                  path: "payment-methods/sepa/:paymentFlow",
                  element: <NewSepaFlowPage />,
                },
              ],
            },
            // -------- ACH --------
            {
              element: (
                <PaymentMethodsProtectedRoute
                  rules={{
                    companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Usd],
                    companyDoesNotHavePaymentMethod: true,
                  }}
                />
              ),
              children: [
                {
                  path: "payment-methods/ach-landing-page",
                  element: <AchLandingPage type={PaymentEngagementType.Combined} />,
                },
                {
                  // NOTE: This is old ACH payment flow (fte + contractor)
                  path: "payment-methods/ach-bank-details",
                  element: <AchFlowPage />,
                },
              ],
            },
            {
              element: (
                <CompanyPaymentsMandateSetupProtectedRoute>
                  <PaymentMethodsProtectedRoute
                    rules={{
                      companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Usd],
                    }}
                  />
                </CompanyPaymentsMandateSetupProtectedRoute>
              ),
              children: [
                {
                  path: "payment-methods/ach-landing-page/contractor",
                  element: <AchLandingPage type={PaymentEngagementType.Contractor} />,
                },
                {
                  path: "payment-methods/ach-landing-page/fte",
                  element: <AchLandingPage type={PaymentEngagementType.Fte} />,
                },
                {
                  path: "payment-methods/ach/:paymentFlow",
                  element: <NewAchFlowPage />,
                },
              ],
            },
            // -------- BACS --------
            {
              element: (
                <PaymentMethodsProtectedRoute
                  rules={{
                    companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Gbp],
                  }}
                />
              ),
              children: [
                {
                  path: "payment-methods/bacs-landing-page",
                  element: <BacsLandingPage />,
                },
              ],
            },
            // -------- PAD --------
            {
              element: (
                <PaymentMethodsProtectedRoute
                  rules={{
                    companyPaymentCurrencyCode: [CompanyCurrencyEnumType.Cad],
                  }}
                />
              ),
              children: [
                {
                  path: "payment-methods/pad-landing-page",
                  element: <PadLandingPage />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}
